import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { OrganisationTagsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createOrganisationTag = (data): any => action(types.CREATE_ORGANISATION_TAG_REQUESTED, data);

export const updateOrganisationTag = (data): any => action(types.UPDATE_ORGANISATION_TAG_REQUESTED, data);

export const deleteOrganisationTag = (organisationTagId): any => action(types.UPDATE_ORGANISATION_TAG_REQUESTED, organisationTagId);

export const getOrganisationTag = (organisationTagId): any => action(types.GET_ORGANISATION_TAG_REQUESTED, organisationTagId);

export const getAllOrganisationTags = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_ORGANISATION_TAGS_REQUESTED, {
  pagination,
  compile,
});

export const selectOrganisationTag = (organisationTagId): any => action(types.SELECT_ORGANISATION_TAG_REQUESTED, {
  currentOrganisationTagId: organisationTagId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createOrganisationTagPending: (payload): any => action(types.CREATE_ORGANISATION_TAG_PENDING, payload),
  createOrganisationTagSuccess: (response): any => {
    const currentOrganisationTag = response.entities.organisationTags[response.result];
    // history.push(`/payment/${currentOrganisationTag.paymentCollection.id}/review`);
    return action(types.CREATE_ORGANISATION_TAG_SUCCESS, {
      organisationTagsById: response.entities.organisationTags,
      currentOrganisationTagId: response.result,
    });
  },
  updateOrganisationTagPending: (payload): any => action(types.UPDATE_ORGANISATION_TAG_PENDING, payload),
  updateOrganisationTagSuccess: (response): any => action(types.UPDATE_ORGANISATION_TAG_SUCCESS, {
    organisationTagsById: response.entities.organisationTags,
    currentOrganisationTagId: response.result,
  }),
  updateOrganisationTagFailed: (error): any => action(types.UPDATE_ORGANISATION_TAG_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationTagPending: (): any => action(types.UPDATE_ORGANISATION_TAG_PENDING, {}),
  deleteOrganisationTagSuccess: (response, userId): any => {
    localStorage.set(userId, { currentOrganisationTagId: null });
    history.push('/organisationTags');

    return action(types.DELETE_ORGANISATION_TAG_SUCCESS, {
      currentOrganisationTagId: response,
    });
  },
  getOrganisationTagPending: (): any => action(types.GET_ORGANISATION_TAG_PENDING, {}),
  getOrganisationTagSuccess: (response): any => action(types.GET_ORGANISATION_TAG_SUCCESS, {
    organisationTagsById: response.entities.organisationTags,
    currentOrganisationTagId: response.result,
  }),
  getOrganisationTagFailed: (error): any => action(types.GET_ORGANISATION_TAG_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationTagFailed: (error): any => action(types.UPDATE_ORGANISATION_TAG_FAIL, {
    backendErrors: error,
  }),
  getAllOrganisationTagsPending: (pagination): any => action(types.GET_ALL_ORGANISATION_TAGS_PENDING, { pagination }),
  getAllOrganisationTagsSuccess: (response, meta): any => action(types.GET_ALL_ORGANISATION_TAGS_SUCCESS, {
    organisationTagsById: response.entities.organisationTags,
    organisationTagIds: response.result,
    meta,
  }),
  getAllOrganisationTagsFailed: (error): any => action(types.GET_ALL_ORGANISATION_TAGS_FAIL, {
    backendErrors: error,
  }),
  createOrganisationTagFailed: (error): any => action(types.CREATE_ORGANISATION_TAG_FAIL, {
    backendErrors: error,
  }),
};

export default null;
